import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './ParallaxBasic.css'
import Background from './hero-background.jpg'
import ScrollPrompt from './arrow-down.svg'
import Waypoint from 'react-waypoint'

import Logo from './solero-logo.png'

/**
 * ParallaxBasic Component
 */
export default class ParallaxBasic extends Component {
  /**
   * Default props.
   *
   * @type {{background, parallaxBasicClassNames: *, parallaxTitle: string, parallaxSubTitle: string, sectionClassName: *, showImage: boolean}}
   */
  static defaultProps = {
    background: Background,
    parallaxBasicClassNames: classNames('Parallax__layer', 'Parallax__layer--base'),
    parallaxTitle: 'Solero®',
    parallaxSubTitle: 'For the Love of Fruit',
    sectionClassName: classNames('ParallaxBasic', 'Parallax__group', 'ParallaxBasic--short'),
    showImage: false
  }

  /**
   * Prop Types
   *
   * @type {{parallaxBasicClassNames: shim, parallaxTitle: shim, parallaxSubTitle: shim, sectionClassName: shim, showImage: shim}}
   */
  static propTypes = {
    parallaxBasicClassNames: PropTypes.string,
    parallaxTitle: PropTypes.string,
    parallaxSubTitle: PropTypes.string,
    sectionClassName: PropTypes.string,
    showImage: PropTypes.bool
  }

  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.waypointEnter = this.waypointEnter.bind(this)
    this.waypointLeave = this.waypointLeave.bind(this)
  }

  /**
   * Waypoint enter
   *
   * @param event
   */
  waypointEnter(event) {
    this.props.setHeaderClassNames(classNames('Header'))
  }

  /**
   * Waypoint leave
   *
   * @param event
   */
  waypointLeave(event) {
    this.props.setHeaderClassNames(classNames('Header', 'Header--bgColor'))
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const {
      background,
      parallaxBasicClassNames,
      parallaxSubTitle,
      parallaxTitle,
      sectionClassName,
      showImage
    } = this.props

    return (
      <section className={sectionClassName}>
        <div className={parallaxBasicClassNames}>
          <img src={background} alt="Background" />
        </div>

        <Waypoint
          scrollableAncestor={document.getElementById('Parallax')}
          debug={false}
          onEnter={this.waypointEnter}
          onLeave={this.waypointLeave}
        >
          <header className="Parallax__layer Parallax__layer--fore">
            {showImage ? (
              <img src={Logo} alt="" />
            ) : (
              <span>
                <h1>{parallaxTitle}</h1>
                <h4>{parallaxSubTitle}</h4>
              </span>
            )}

            <div className="ScrollPrompt">
              <img src={ScrollPrompt} alt="Scroll" />
            </div>
          </header>
        </Waypoint>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/parallaxBasic/ParallaxBasic.jsx